import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const TableContainer = styled(Box).attrs({
  backgroundColor: 'background',
  padding: '10px',
  overflow: 'hidden',
})`
  border: ${({ theme }) => `1px solid ${theme.colors.heavyLineOutline}`};
  border-radius: 5px;
`;

export const TableHeader = styled(Text).attrs({
  size: 'xsmall',
  fontWeight: 'bold',
  color: 'secondaryText',
})``;

export const TableRow = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  mb: '4px',
})`
  &:last-child {
    margin-bottom: 0;
  }
`;

export const IconWrapper = styled(Box)`
  color: ${({ theme }) => theme.colors.secondaryLink};
`;
